/* eslint-disable import/prefer-default-export */

export enum DeploymentEnvironment {
  development = 'DEVELOPMENT',
  production = 'PRODUCTION',
  test = 'TEST',
}
